import { ProtocolRewardConfig } from '../../models/paymentConfig';
import client from '../httpclient';

function getProtocolRewardConfig(
  protocolId: string,
): Promise<ProtocolRewardConfig> {
  return client.get(
    `/re/v1/protocol/${protocolId}/rewardConfig`,
  );
}

export default getProtocolRewardConfig;
